module.exports = __webpack_public_path__ + "img/american-kestrel.76e99db3.jpg";